import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/utils';
import { isIOS } from '@standardnotes/ui-services';
import { useEffect, useRef } from 'react';
export function PlainEditorSearchBackdrop({ html, textareaRef, typographyClassName, syncDependency }) {
    const backdropScrollRef = useRef(null);
    useEffect(() => {
        const textarea = textareaRef.current;
        const backdrop = backdropScrollRef.current;
        if (!textarea || !backdrop) {
            return;
        }
        const syncScroll = () => {
            backdrop.scrollTop = textarea.scrollTop;
            backdrop.scrollLeft = textarea.scrollLeft;
        };
        syncScroll();
        textarea.addEventListener('scroll', syncScroll);
        return () => {
            textarea.removeEventListener('scroll', syncScroll);
        };
    }, [textareaRef, syncDependency]);
    const backdropClassName = classNames('plain-editor-search-backdrop font-editor whitespace-pre-wrap break-words', typographyClassName, isIOS() && '!pb-12');
    return (_jsx("div", { ref: backdropScrollRef, className: "plain-editor-search-backdrop-scroll pointer-events-none absolute inset-0", "aria-hidden": true, children: _jsx("div", { className: backdropClassName, dir: "auto", dangerouslySetInnerHTML: { __html: html } }) }));
}
